import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { isMobileOnly } from 'react-device-detect';
import {
    closeModal,
    openModal,
    setRemoveToCustomerSurfingBlockage,
    setReadyToPurchase,
    setReadyToPurchaseFamily,
    setSaleActiveStep,
} from '../cellcomAbroadBlockSlice';
import { otpValidationPopupContent, customerTypeEnum, popupReasonEnum, saleActiveStep } from '../cellcomAbroadVariables';
import { formatBlockedPhonesForPopup } from '../cellcomAbroadUtilities';
import { Container } from 'reactstrap';
import PopupHeadlineComponent from './PopupSharedComponents/PopupHeadlineComponent';
import PopupImageComponent from './PopupSharedComponents/PopupImageComponent';
import PopupDescriptionComponent from './PopupSharedComponents/PopupDescriptionComponent';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import PopupButtonAsLinkComponent from './PopupSharedComponents/PopupButtonAsLinkComponent';
import Lottie from 'react-lottie';
import PaperPlane from '../../../../animations/paperPlane.json';
import {
    gaDataIsBlockedOnLoad,
    gaUnblockDataUsage,
    gaStayWithBlockedDataUsage,
    gaUnblockDataUsageBusinessIndividual,
    gaStayWithBlockedDataUsageBusinessIndividual,
    gaCloseBlockedDataUsagePopupBusinessIndividual,
} from './../../AbroadTicketBlock/gaReports';
import ExclamationMark from './images/exclamationMark.svg';
import ThemedLottie from '../../../Shared/ThemedLottie/ThemedLottie';
import { ThemeColorEnum } from '../../../../utilities/theme/ThemeColorEnum';
import Image from 'app/Components/Shared/Image/image';

const DataUsageIsBlockedPopupComponent = (props) => {
    useEffect(() => {
        gaDataIsBlockedOnLoad(
            props.businessOrPrivate,
            props.data.startedFromPackage,
            props.data.epiStyleInitializationData.businessIndividualLobby
        );
    }, []);

    const isFamilyBundle = props.data.selectedAbroadPackage?.isFamilyBundle;

    const getHeadlineContent = () => {
        if (isFamilyBundle) {
            return null;
        }

        if (props.data.epiStyleInitializationData.businessIndividualLobby) {
            return <PopupHeadlineComponent title={otpValidationPopupContent.subsriberSurfIsBlockedBusinessIndividual.headline} />;
        } else {
            return <PopupHeadlineComponent title={otpValidationPopupContent.subsriberSurfIsBlocked.headline} />;
        }
    };

    const getDescriptionContent = () => {
        if (props.data.epiStyleInitializationData.businessIndividualLobby) {
            const description = otpValidationPopupContent.subsriberSurfIsBlockedBusinessIndividual.description.replace(
                'phoneNumber',
                props.data.businessIndividualData.selectedAccountNumber
            );
            return <PopupDescriptionComponent description={description} />;
        } else {
            const blockedPhones = props.data.familyBundleData?.surfBlockedSubscriberPhones || [];

            if (isFamilyBundle) {
                const content = otpValidationPopupContent.subsriberSurfIsBlockedFamilyBundleMultiple;
                const boldDescription =
                    content.descriptionBold + "<br>" + formatBlockedPhonesForPopup(blockedPhones);
                return <PopupDescriptionComponent boldDescription={boldDescription} />;
            }

            const blockedPhone = props.data.otpData.otpPhone;
            const boldDescription = otpValidationPopupContent.subsriberSurfIsBlocked.descriptionBold.replace(
                'phoneNumber',
                blockedPhone
            );
            const description = otpValidationPopupContent.subsriberSurfIsBlocked.description;
            return <PopupDescriptionComponent boldDescription={boldDescription} description={description} />;
        }
    };

    const getButtonsContent = () => {
        if (props.data.epiStyleInitializationData.businessIndividualLobby) {
            return (
                <>
                    <BtnSubmit
                        isBusiness={true}
                        text={otpValidationPopupContent.subsriberSurfIsBlockedBusinessIndividual.buttonText}
                        onclick={() => subscriberSurfIsBlockedBusinessIndividualAction(false)}
                    />
                    <BtnSubmit
                        isBusiness={true}
                        text={otpValidationPopupContent.subsriberSurfIsBlockedBusinessIndividual.additionalButtonText}
                        onclick={() => subscriberSurfIsBlockedBusinessIndividualAction(true)}
                    />
                    <PopupButtonAsLinkComponent
                        text={otpValidationPopupContent.subsriberSurfIsBlockedBusinessIndividual.buttonAsLinkText}
                        onClick={() => gaAndClosePopup()}
                    />
                </>
            );
        } else {
            return (
                <>
                    <BtnSubmit
                        isBusiness={props.data.otpData.validatedCostumerData?.accountType != customerTypeEnum.PRIVATE}
                        text={`תשאירו את החסימת גלישה`}
                        onclick={() => subscriberSurfIsBlockedAction(false)}
                    />
                    <PopupButtonAsLinkComponent text={`הסירו את חסימת הגלישה`} onClick={() => subscriberSurfIsBlockedAction(true)} />
                </>
            );
        }
    };

    const continueFamilyBundlePurchase = () => {
        if (props.data.selectedAbroadPackage?.isFamilyBundle) {
            props.setSaleActiveStep(saleActiveStep.LOADER);
        }
        if (!props.data.otpData?.isFamilyProcess) {
            props.setReadyToPurchase(true);
        } else {
            props.setReadyToPurchaseFamily(true);
        }
        props.closeModal();
    };

    const subscriberSurfIsBlockedAction = (unBlockDataUsage) => {
        if (
            !props.data.epiStyleInitializationData.businessIndividualLobby &&
            !props.data.otpData.validatedCostumerData.accountSegmentMatchSoc &&
            !props.data.otpData?.isFamilyProcess
        ) {
            props.openModal(popupReasonEnum.ACCOUNT_SEGMENT_MATCH_SOC);
        } else {
            if (unBlockDataUsage) {
                gaUnblockDataUsage(props.businessOrPrivate, props.data.startedFromPackage);
                props.setRemoveToCustomerSurfingBlockage();
            } else {
                gaStayWithBlockedDataUsage(props.businessOrPrivate, props.data.startedFromPackage);
            }
            continueFamilyBundlePurchase();
        }
    };

    const subscriberSurfIsBlockedBusinessIndividualAction = (unBlockDataUsage) => {
        if (unBlockDataUsage) {
            gaUnblockDataUsageBusinessIndividual();
            props.setRemoveToCustomerSurfingBlockage();
        } else {
            gaStayWithBlockedDataUsageBusinessIndividual();
            props.setReadyToPurchase(true);
        }
        props.closeModal();
    };

    const getPopupIcon = () => {
        if (isFamilyBundle) {
            return (
                <div style={{ textAlign: 'center', margin: '0 !important' }}>
                    <Image
                        src={ExclamationMark}
                        alt="exclamation"
                        width={120}
                        height={120}
                    />
                </div>
            )
        } else {
            return (
                <ThemedLottie animationData={PaperPlane}  color={ThemeColorEnum.PRIMARY} loop={false} width={isMobileOnly ? 180 : 250} />            )
        }
    }

    function gaAndClosePopup() {
        gaCloseBlockedDataUsagePopupBusinessIndividual();
        props.closeModal();
    }

    return (
        <Container>
            {getHeadlineContent()}
            {getPopupIcon()}
            {getDescriptionContent()}
            {getButtonsContent()}
        </Container>
    );
};

const mapStateToProps = (state) => {
    return {
        data: state.cellcomAbroad,
    };
};

const mapDispatchToProps = {
    closeModal,
    setRemoveToCustomerSurfingBlockage,
    setReadyToPurchase,
    setReadyToPurchaseFamily,
    setSaleActiveStep,
    openModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(DataUsageIsBlockedPopupComponent);
